import useSWRBase, { SWRConfiguration } from 'swr'

const DEFAULT_SWR_OPTIONS: SWRConfiguration = {
  revalidateIfStale: false,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
}

export const useSWRFetcher = <TData = unknown>(
  key: string,
  fetcher: () => Promise<TData>,
  swrOptions?: SWRConfiguration
) => {
  const isServer = typeof window === 'undefined'
  const cacheKey = isServer ? null : key

  return useSWRBase(cacheKey, fetcher, {
    ...DEFAULT_SWR_OPTIONS,
    ...(swrOptions || {}),
  })
}

export const useSWR = <TData = unknown>(
  key: string,
  fetcher: () => Promise<TData>,
  swrOptions?: SWRConfiguration
) => {
  return useSWRBase(key, fetcher, {
    ...DEFAULT_SWR_OPTIONS,
    ...(swrOptions || {}),
  })
}
